import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import AuthLayout from './AuthLayout';
import { Button, Alert, Row, Col, Container, Card } from "react-bootstrap";
import { Navigate, Link, useLocation } from "react-router-dom";
import FormInput from '../../Components/FormInput';
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'
import { login } from '../../redux/actions/AuthActions'
import LogoDark from "../../assets/images/logo-dark.png";
import LogoLight from "../../assets/images/logo-light.png";
import Header from '../../Components/PageComponent/Layout/Header';
import Footer from '../../Components/PageComponent/Layout/Footer';

/* bottom links */
const BottomLink = () => {
    const { t } = useTranslation();

    return (
        <Row className="mt-3">
            <Col className="text-center">
                <p>
                    <Link to={"/auth/forget-password"} className="text-white-50 ms-1">
                        {t("Forgot your password?")}
                    </Link>
                </p>
            </Col>
        </Row>
    );
};

export default function Login() {
    const { t } = useTranslation();

    const { AuthReducer: { loading, errors, isAuthenticated } } = useSelector(state => state)
    const [formData, setFormData] = useState({})
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const inputHandler = (e) => {
        const { value, name } = e.target
        setFormData({ ...formData, [name]: value })
    }
    const selectMobileHandler = (e) => {
        const { value, name } = e.target;
        const numericValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
        if (numericValue.length <= 10) {
            console.log(numericValue, name);
            setFormData(prevFormData => ({
                ...prevFormData,
                [name]: numericValue,
            }));
        }
    };



    useEffect(() => {
        if (isAuthenticated) {
            navigate('/')
        }
    }, [isAuthenticated])

    const submitHandler = () => {
        dispatch(login(formData));
    }

    return (
        <>
            <Header />
            <main className="block-main">
                <Container className='mt-4'>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={9}>
                            <Card className="bg-pattern">
                                <Card.Body className="p-4">
                                    <div className="text-center w-75 m-auto">
                                        <div className="auth-brand">
                                            <Link to="/" className="logo logo-dark text-center">
                                                <span className="logo-lg">
                                                    <img src={LogoDark} alt="Logo Dark" height="40" />
                                                </span>
                                            </Link>

                                            <Link to="/" className="logo logo-light text-center">
                                                <span className="logo-lg">
                                                    <img src={LogoLight} alt="Logo Light" height="40" />
                                                </span>
                                            </Link>
                                        </div>
                                        <p className="text-muted mb-4 mt-3">Enter your mobile and password to access admin panel.</p>
                                    </div>

                                    <FormInput
                                        label={t("Mobile")}
                                        type="text"
                                        errors={errors}
                                        name="mobile"
                                        value={formData.mobile}
                                        placeholder="Enter your Mobile"
                                        onChange={(e) => selectMobileHandler(e)}
                                        containerClass={"mb-3"}
                                    />
                                    <FormInput
                                        label={t("Password")}
                                        type="password"
                                        name="password"
                                        errors={errors}
                                        value={formData.password}
                                        placeholder="Enter your password"
                                        onChange={inputHandler}
                                        containerClass={"mb-3"}
                                    />
                                    {errors?.message && (
                                        <Row className="my-2">
                                            <Col className=" text-center text-danger fw-bold">
                                                {errors?.message}
                                            </Col>
                                        </Row>
                                    )}

                                    <div className="text-center d-grid">
                                        <Button variant="primary" type="submit" disabled={loading} onClick={submitHandler} >
                                            {t("Log In")}
                                        </Button>
                                    </div>
                                    <Row className="mt-3">
                                        <Col className="text-center ">
                                            <p>
                                                <Link to={"/Register"} className="text-black-50 ms-1">
                                                    {t("Register Here")}
                                                </Link>
                                            </p>
                                        </Col>
                                        <Col className="text-center ">
                                            <p>
                                                <Link to={"/forgot-password"} className="text-black-50 ms-1">
                                                    {t("Forgot Password")}
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>


                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </>
    );
}